import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { selectUserState } from '@core/data-access/selectors/user.selectors';
import { Store } from '@ngrx/store';
import { catchError, mergeMap, take } from 'rxjs';
import { ErrorCode } from '@shared/utils/models/http.model';
import { UserActions } from '@core/data-access/actions/user.actions';
import { environment } from 'src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const store: Store = inject(Store);
  return store.select(selectUserState).pipe(
    take(1),
    mergeMap(({ user }) => {
      if (user && req.url.startsWith(environment.apiUrlBase)) {
        req = req.clone({
          setHeaders: {
            Authorization: `${user.type} ${user.token}`,
          },
        });
      }
      return next(req);
    }),
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.error.code === ErrorCode.NOT_LOGGED_IN) {
        store.dispatch(UserActions.clearUser());
      }
      throw error;
    })
  );
};
